import {Text} from '../1elements'

const Link = ({href, children, className}) => {
    return (
        <a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <Text className={className}>{children}</Text>
        </a>
    )
}

export default Link
